import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { UserLink } from '../../Links/Links';
import { logout } from '../../../common/actions/authActions';
import { Desktop, Mobile } from '../../MediaQuery';
import { MobileMarginButtonWrapper } from './style';

const mapStateToProps = ({ api: { email, basePathAdmin, basePathAccount, hasAdminArea } }) => ({
  basePathAdmin,
  basePathAccount,
  hasAdminArea,
  email,
});

const mapDispatchToProps = dispatch => ({
  handleLogout: email => dispatch(logout(email)),
});

// TODO: refactor in functional component
class AuthLinks extends Component {
  render() {
    const { email, handleLogout, basePathAccount, basePathAdmin, hasAdminArea } = this.props;
    return (
      <>
        <Desktop>
          <UserLink id="my-account-desktop" href={basePathAccount} data-cy="header-account-link" padding="10px 0 0 0">
            My account
          </UserLink>
          {hasAdminArea && (
            <UserLink href={basePathAdmin} padding="10px 0 0 15px">
              admin
            </UserLink>
          )}
        </Desktop>

        <MobileMarginButtonWrapper margin="0 20px 0 0">
          <UserLink onClick={() => handleLogout(email)} data-cy="header-signout-link" padding="10px 15px 0">
            Sign out
          </UserLink>
        </MobileMarginButtonWrapper>

        <Mobile>
          <MobileMarginButtonWrapper margin="0 20px 0 0">
            <UserLink id="my-account-mobile" href={basePathAccount} data-cy="anchor-navigation-my-account">
              My account
            </UserLink>
          </MobileMarginButtonWrapper>
        </Mobile>
      </>
    );
  }
}

AuthLinks.propTypes = {
  basePathAccount: PropTypes.string,
  basePathAdmin: PropTypes.string,
  email: PropTypes.string,
  hasAdminArea: PropTypes.bool,
  handleLogout: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AuthLinks);
